import axios from "axios";
import { cmsEnv, cmsHeaders } from "../exports/exports";

export const fetchFacilitiesList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/facilities-facilities-list`,
      {
        headers: {
          ...cmsHeaders,
          ...cmsEnv,
        },
      },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
